import { ViewBooking } from "collins-js-sdk";
import { fetchBookingV4FromAPI } from "../../../../../APIs/Booking/GetBooking";
import { mapBookingV4ToState } from "../../../../../APIs/Booking/UpdateBooking";
import { DiaryContextType } from "../../../../../context/DiaryContext";
import { getDayOrdinalFromDate } from "../../../../../utils/helpers";
import {
  getBookingAssignedAreaNamesAsString,
  getBookingDurationAsString
} from "../../../../../utils/singleBooking";
import { SelectedBookingTabEnum } from "../Tabs/SelectedBookingTabsController";
import {
  getBookingRefHyperlink,
  getBookingStatusIcon
} from "./LinkedBookingCustomFields";

type GetLinkedBookingDetailsType = {
  linkedBookingIds?: string[];
  diaryContext: DiaryContextType;
};
export const getLinkedBookingDetails = async ({
  linkedBookingIds,
  diaryContext
}: GetLinkedBookingDetailsType): Promise<ViewBooking[]> => {
  const { bookings } = diaryContext;
  if (!linkedBookingIds || !bookings) {
    return [];
  }

  return await Promise.all(
    linkedBookingIds.map(async (id) => {
      // look for linked bookings in same day current booking list
      let booking = bookings.find((row) => row.id === id);
      if (!booking) {
        // Load bookings individually if not found
        const response = await fetchBookingV4FromAPI(id);
        if (response) {
          booking = {
            ...mapBookingV4ToState(response),
            linkedBookings: linkedBookingIds
              .filter((id) => id !== diaryContext?.selectedBooking?.id)
              .map((id) => ({
                id: { id }
              }))
          };
        }
      }

      return { ...booking };
    })
  );
};

type MapLinkedBookingsTableDataTypeResponse = {
  reference: JSX.Element;
  typeName?: string;
  site?: string;
  time?: string;
  date?: string;
  duration?: string;
  status: JSX.Element;
  area?: string;
};
type MapLinkedBookingsTableDataType = {
  bookings?: ViewBooking[];
  diaryContext: DiaryContextType;
  setSelectedTabKey?: (value: SelectedBookingTabEnum) => void;
};
export const mapLinkedBookingsTableData = ({
  bookings,
  diaryContext,
  setSelectedTabKey
}: MapLinkedBookingsTableDataType): MapLinkedBookingsTableDataTypeResponse[] => {
  const { venues } = diaryContext;
  if (!venues || !bookings) {
    return [];
  }

  return bookings.map((booking) => {
    const reference = getBookingRefHyperlink(
      booking,
      diaryContext,
      setSelectedTabKey
    );
    const site = venues.find((venue) => venue._id === booking?.venueId);
    const bookingDate = new Date(booking?.date ?? "");
    const date = `${getDayOrdinalFromDate(
      bookingDate
    )} ${bookingDate.toLocaleDateString("en-GB", {
      month: "short"
    })}`;
    const duration = booking
      ? getBookingDurationAsString(booking)
          .split(" hr")
          .join("hr")
          .split(" mins")
          .join("m")
      : "";
    const status = getBookingStatusIcon(booking);
    const area = booking ? getBookingAssignedAreaNamesAsString(booking) : "";

    return {
      reference,
      typeName: booking?.type?.name,
      site: site?.title ?? "",
      time: booking?.time ?? "",
      date,
      duration,
      status,
      area
    };
  });
};
